import axios from 'axios';
import { getCurrentLanguage } from './i18n';

// import { DefaultResponseData } from '@/interfaces/axios';
// import logger from '@/utils/logger';

/**
 * 生成随机字符串，默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
 * @param {number} len 要生成字符串的长度
 * @return {string} 随机字符串
 */
export const randomString = (len = 9) => {
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  let str = '';
  for (let i = 0; i < len; i++) {
    str += chars[Math.floor(Math.random() * chars.length)];
  }
  return str;
};

// 默认头
const JSON_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const testServerList = [
  'wemeet-dev.prod.com',
  'wemeet-dev.dev.com',
  'test.txmeeting.tencent.com',
  '9.81.28.132',
  'localhost',
  'wemeet-dev.mobile.com',
  'voovmeeting.test.ibg.com',
  'test.web.voovmeeting.com',
];

const devServerList = ['localhost'];

const getAPIRoot = (prefixType: RequestOption['prefixType']) => {
  if (prefixType) {
    if (prefixType === 'webtapi') {
      return '/wemeet-tapi';
    }
  }
  const isTest = !!testServerList.find((i) => window.location.href.indexOf(i) > -1);
  const isDev = !!devServerList.find((i) => window.location.href.indexOf(i) > -1);

  // return '/wemeet-webapi';
  return isDev || isTest ? '/wemeet-webapi-test' : '/wemeet-webapi';
};

const defaultData: DefaultResponseData = {
  message: '',
  code: -1,
  // success: false,
};

interface RequestOption {
  url: string;
  data: any;
  type?: 'GET' | 'POST';
  prefixType?: 'webapi' | 'webtapi';
}

export interface DefaultResponseData<T = any> {
  message: string;
  code: number;

  data?: T;
  status?: number;
}

const request = ({ url, data, type = 'POST', prefixType }: RequestOption): Promise<DefaultResponseData> => {
  const reqParam = {
    c_os: 'web',
    c_os_version: 1,
    c_os_model: 'web',
    c_timestamp: +new Date(),
    c_instance_id: 5,
    c_nonce: randomString(8),
    // c_app_id: store.state.user.appid,
    c_app_id: '',
    c_app_version: '1.2.9.0', // VooV Meeting终端版本号,目前web也得先这么写1.2.9.0，发短信的时候才是以voovmeeting公司名去发
    c_lang: getCurrentLanguage() === 'zh-CN' ? 'zh-cn' : 'en-us',
    c_district: 1,
  };

  return axios({
    baseURL: `${getAPIRoot(prefixType)}/`,
    url,
    data,
    params: reqParam,
    headers: JSON_HEADERS,
    method: type,
  })
    .then((response) => {
      const { status } = response;
      const { message, code, data, ...ext } = response.data;

      if (status < 400) {
        return {
          ...defaultData,
          message,
          data,
          // 原来这这里已经做了映射
          // success: code === 0,
          code,
          ...ext,
        };
      }
      return {
        ...defaultData,
        message,
        data,
        // success: false,
        code: -1001,
        status,
        ...ext,
      };
    })
    .catch((error) => {
      throw error;
    });
};

export default request;
